import { MEWSRatesEN } from '@/core/components/help-and-support/quick-answers/mews-rates/en'
import { MEWSRatesES } from '@/core/components/help-and-support/quick-answers/mews-rates/es'
import { useIntlSelector } from '@/core/hooks/useIntlSelector'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_layout/dashboard/help-and-support/quick-answers/mews-rates/'
)({
  component: RouteComponent,
})

function RouteComponent() {
  const { locale } = useIntlSelector()

  switch (locale) {
    case 'en':
      return <MEWSRatesEN />
    case 'es':
      return <MEWSRatesES />
  }
}
